import Tab from 'vux/src/components/tab/tab.vue'
import TabItem from 'vux/src/components/tab/tab-item.vue'
import XInput from 'vux/src/components/x-input/index.vue'
import Group from 'vux/src/components/group/index.vue'
import CheckIcon from 'vux/src/components/check-icon/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import Toast from 'vux/src/components/toast/index.vue'
import Divider from 'vux/src/components/divider/index.vue'


export default {
name: 'thirdPartyLogin',

components: {
Tab,
TabItem,
XInput,
Group,
CheckIcon,
XButton,
Toast,
Divider
},
data () {
return {
phoneReg: /^1[3456789]\d{9}$/,  //手机号正则
timerText: '获取验证码',
isDisabled: false,  //获取验证码按钮的 disabled
disabledActive: false,  //获取验证码后倒计时的样式
maskValue: '',  //手机号码双向绑定
maskValue2: '', //验证码双向绑定
}
},
methods: {
getCodeFun () {   //获取验证码的函数
this.$request.post('/message/verificationCode',{
phone: this.maskValue.replace(/\ +/g, "")
},).then(data => {
console.log(data)
}).catch(e => {
console.log(e)
})
},
back () {
this.$router.go(-1)
},
phoneLoginFun (data) {   //手机登录函数

this.$request.post('/user/bindQQ',data,).then(data => {
if(data.code == 0){   //登录成功
this.$vux.loading.hide()
this.$vux.toast.show({
type: 'success',
text: data.msg,
time: 600
})
let vPath = this.$route.query.fullPath
this.setCookie('_token', data.obj.token, 0.288)
setTimeout(() => {
vPath ? this.$router.push({path: vPath}) : this.$router.push({path: '/'})



}, 650);
}else{    //否则
this.$vux.loading.hide()
this.$vux.toast.show({
type: 'cancel',
text: data.msg
})
}
}).catch(e => {
this.$vux.loading.hide()
this.$vux.toast.show({
type: 'cancel',
text: e
})
})
},
getProvince () {
var p = new Promise((resolve, reject) => {
var adddress = '',
province = '',
loadScript;
function loadJS(url) { //加载js
loadScript = document.createElement("script");
loadScript.type = "text/javascript";
loadScript.src = url;
document.body.appendChild(loadScript);
}
loadJS("https://pv.sohu.com/cityjson?ie=utf-8");
loadScript.onload = function () {

adddress = returnCitySN["cname"]


if(adddress.split('省').length != 1) {
province = adddress.split('省')[0]+'省'
}else if(adddress.split('区').length != 1){
province = adddress.split('区')[0]+'区'
}else{
province = adddress.split('市')[0]+'市'
}
resolve(province)
}
})
return p
},
setCookie(cname, cvalue, exdays) {



var d = new Date();
d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
var expires = "expires=" + d.toUTCString();
document.cookie = cname + "=" + cvalue + "; " + expires+"; path=/"   
console.log(d)
},
getCode () {  //获取验证码
let phoneText = this.maskValue.replace(/\ +/g, "");

if(phoneText == ''){
this.$vux.toast.show({
type: 'warn',
text: '手机号码为空'
})
return false;
}else{
if(!this.phoneReg.test(phoneText)){
this.$vux.toast.show({
type: 'warn',
text: '手机号码有误'
})
return false;
}else{
this.getCodeFun()
this.isDisabled = true
this.disabledActive = true
let codeTimer = 60
let timeOutFn = setInterval(() => {
this.timerText = codeTimer-- + 's 后重新获取'
if(codeTimer == -1){
clearInterval(timeOutFn)
this.timerText = '获取验证码'
this.isDisabled = false
this.disabledActive = false
}
}, 1000);
}
}
},
phoneLogin () { //手机登录
let phoneText = this.maskValue.replace(/\ +/g, ""),
code = this.maskValue2.replace(/\ +/g, ""),
that = this;
if(phoneText == ''){
this.$vux.toast.show({
type: 'warn',
text: '手机号码为空'
})
return false;
}else if(!this.phoneReg.test(phoneText)){
this.$vux.toast.show({
type: 'warn',
text: '手机号码有误'
})
return false;
}
if(code == ''){
this.$vux.toast.show({
type: 'warn',
text: '验证码为空'
})
return false;
}
this.$vux.loading.show({
text: 'Loading'
})
this.getProvince().then((province) => {

this.$request.post('/message/verificationCodeByCode',{
phone: phoneText,
verificationCode: code
},).then(data => {
if(data.code == 0){

let access_token = this.$route.query.accessToken,
openId = this.$route.query.openId,
nickname = this.$route.query.nickname;





that.getProvince().then((province) => {
let datas = {
openId,
province,
phone: phoneText,
qqName: decodeURIComponent(nickname),
invitationCode: that.$common.getCookie('_mobileInviteCode')
}
that.phoneLoginFun(datas)
})










}else{
this.$vux.loading.hide()
this.$vux.toast.show({
type: 'cancel',
text: data.msg
})
}
}).catch(e => {
this.$vux.loading.hide()
this.$vux.toast.show({
type: 'cancel',
text: e
})
})
})

},
},
created () {

},
mounted() {

},
}



// WEBPACK FOOTER //
// ./src/views/thirdPartyLogin/script.js